<script>
export default {
  props: ['visible', 'title', 'id'],
  data() {
    return {

    }
  },
  methods: {
    sidebarChangeHandler() {

    }
  }
}
</script>

<template>
  <div>
    <b-sidebar
        no-header
        shadow
        right
        :aria-expanded="visible"
        :visible="visible"
        :width="'465px'"
        no-enforce-focus
        aria-labelledby="mindmap-sidebar-header"        
    >
        <div class="p-2" style="padding: 1rem !important;">
          <h4 id="mindmap-sidebar-header">{{ title }}<br v-if="id"><span v-if="id" style="font-size: 12px; float: right">ID: {{ id }}</span></h4>
          <slot/>
        </div>
    </b-sidebar>
  </div>
</template>

<style scoped>

</style>